import React from "react";
import { useTranslation } from "react-i18next";
import { SearchResult } from "@planzone/dto";

import { Props } from "./types";
import { Project } from "./project";
import { Task } from "./task";
import { Milestone } from "./milestone";
import styles from "./styles.scss";

function sortResultsByType(results: SearchResult[]) {
  return results.reduce<{ type: string; results: SearchResult[] }[]>(
    (acc, result) => {
      const index = acc.findIndex(({ type }) => type === result.type);

      return index !== -1
        ? [
            ...acc.slice(0, index),
            { ...acc[index], results: [...acc[index].results, result] },
            ...acc.slice(index + 1),
          ]
        : [...acc, { type: result.type, results: [result] }];
    },
    [],
  );
}

function SearchResults({ query, results }: Props) {
  const { t } = useTranslation();
  const sortedResults = sortResultsByType(results);

  return (
    <div className={styles.searchResults}>
      {sortedResults.map(({ type, results }) => (
        <div key={type} className={styles.section}>
          <h4 className={styles.title}>{t(`searchPage.types.${type}`)}</h4>
          <ul className={styles.list}>
            {results.map((result) => (
              <li key={result.args.uuid} className={styles.result}>
                {result.type === "project" && (
                  <Project query={query} args={result.args} />
                )}
                {result.type === "task" && (
                  <Task query={query} args={result.args} />
                )}
                {result.type === "milestone" && (
                  <Milestone query={query} args={result.args} />
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export { SearchResults };
